<template>
  <filter-wrapper
    class="date-filter"
    :label="field.label"
    :display-add-value-button="true"
    :removable="removable"
    @removeFilter="removeFilter"
    @addValue="addValue"
  >
    <div class="filter__content__values">
      <div
        class="filter__content__values__value"
        v-for="(value, index) in filterData.field.filter.values"
        :key="index"
      >
        <b-form-input
          type="text"
          class="filter__content__values__value__min"
          v-model="value.minDate"
          placeholder="Минимум"
        />
        <b-form-input
          type="text"
          class="filter__content__values__value__max"
          v-model="value.maxDate"
          placeholder="Максимум"
        />
        <b-button
          variant="outline-danger"
          class="filter__content__values__value__remove-button"
          v-b-popover.hover.right="'Удалить значение'"
          @click="removeValue(value)"
        >
          <b-icon icon="x" />
        </b-button>
      </div>
    </div>
  </filter-wrapper>
</template>
<script>
import filterMixin from "@/components/Tables/Filters/mixins/filterMixin";
import FilterWrapper from "@/components/Tables/Filters/FilterWrapper";
import validateDate from "@/helpers/validateDate";

export default {
  components: { FilterWrapper },
  mixins: [filterMixin],
  methods: {
    handler(item) {
      let value = item[this.field.key];
      if (typeof this.field.formatter === "function")
        value = this.field.formatter(value, this.field.key, item);
      if (!validateDate(value)) return false;

      let itemDate = new Date(
        value
          .split(".")
          .reverse()
          .join("-")
      );

      let searchValues = this.filterData.field.filter.values.filter(
        ({ minDate, maxDate }) => validateDate(minDate) || validateDate(maxDate)
      );
      if (searchValues.length > 0)
        return searchValues.some(({ minDate, maxDate }) => {
          if (
            validateDate(minDate) &&
            new Date(
              minDate
                .split(".")
                .reverse()
                .join("-")
            ) > itemDate
          )
            return false;
          return !(
            validateDate(maxDate) &&
            new Date(
              maxDate
                .split(".")
                .reverse()
                .join("-")
            ) < itemDate
          );
        });
      else return true;
    },
    addValue() {
      this.filterData.field.filter.values.push({
        minDate: null,
        maxDate: null
      });
    },
    removeValue(value) {
      this.filterData.field.filter.values.splice(
        this.filterData.field.filter.values.indexOf(value),
        1
      );
    }
  }
};
</script>
